import Controller from '../../utilities/position-settings-base-controller';

export default class extends Controller {
}
